import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Checkbox } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({}));

const StatusField = ({ handleToggleSelection, selectedIds, ...props }) => {
  const classes = useStyles();
  const record = useRecordContext(props);

  const checked = record ? selectedIds.indexOf(record.record.id) >= 0 : false;

  return (
    <Checkbox
      color="primary"
      className={`select-item ${classes.checkbox}`}
      checked={checked}
      onClick={() => handleToggleSelection(record)}
    />
  );
};

export default StatusField;
